"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hashOnion = exports.generateHashOnionSeed = void 0;

var hash_1 = require("./hash");

var nacl_1 = require("./nacl");

var HASH_SIZE = 16;
var INPUT_SIZE = 64;
var defaultCount = 1000000;
var defaultDistance = 1000;

var generateHashOnionSeed = function generateHashOnionSeed() {
  return hash_1.hash(nacl_1.getRandomBytes(INPUT_SIZE)).slice(0, HASH_SIZE);
};

exports.generateHashOnionSeed = generateHashOnionSeed;

var hashOnion = function hashOnion(seed) {
  var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultCount;
  var distance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultDistance;

  if (count < distance) {
    throw new Error('Invalid count or distance. Count must be greater than distance');
  }

  if (count % distance !== 0) {
    throw new Error('Invalid count. Count must be multiple of distance');
  }

  var previousHash = seed;
  var hashes = [seed];

  for (var i = 1; i <= count; i += 1) {
    var nextHash = hash_1.hash(previousHash).slice(0, HASH_SIZE);

    if (i % distance === 0) {
      hashes.push(nextHash);
    }

    previousHash = nextHash;
  }

  return hashes.reverse();
};

exports.hashOnion = hashOnion;